<script>
import RegistryWorkspace from "../components/registry/RegistryWorkspace.vue";

export default RegistryWorkspace;
</script>
